/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_SearchInputs */

const en_coaches_page_search = /** @type {(inputs: Coaches_Page_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach nearby`)
};

const pl_coaches_page_search = /** @type {(inputs: Coaches_Page_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener w pobliżu`)
};

/**
* | output |
* | --- |
* | "Coach nearby" |
*
* @param {Coaches_Page_SearchInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_search = /** @type {((inputs?: Coaches_Page_SearchInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_SearchInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_search(inputs)
	return en_coaches_page_search(inputs)
});